"use client";
import { Track } from "@/src/lib/tracking";

import { useMutation } from "@tanstack/react-query";
import { safeStringifyError } from "utils";
import { useOspApiClientProvider } from "@hooks/useOspApiClientProvider";
import type {
  ChatClient,
  OnboardingCompleteResponse,
} from "@features/api/ChatApi";
import { setEdgenOnboardingStepCookie } from "@utils/onboarding";

/**
 * POST /onboarding/complete — 标记当前用户 Onboarding 流程已完成。
 */
export async function runCompleteOnboardingRequest(
  chatApi: ChatClient<unknown> | undefined,
): Promise<OnboardingCompleteResponse> {
  if (!chatApi?.onboarding?.completeCreate) {
    throw new Error("[useCompleteOnboarding] chatApi.onboarding unavailable");
  }

  const res = await chatApi.onboarding.completeCreate();
  if (res?.error) {
    Track.log("warn", "useCompleteOnboarding", "complete failed", {
      cause: String(safeStringifyError(res.error)),
    });
    throw res.error;
  }

  return res.data ?? {};
}

export const useCompleteOnboarding = () => {
  const { chatApi } = useOspApiClientProvider();

  return useMutation({
    mutationFn: async (): Promise<OnboardingCompleteResponse> => {
      Track.log("info", "useCompleteOnboarding", "complete request");
      return runCompleteOnboardingRequest(chatApi);
    },
    onSuccess: () => {
      setEdgenOnboardingStepCookie(3);
    },
  });
};
